import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";

const TareaDetalleValidarPedido = React.lazy(
  () =>
    import("../components/task/accountManager/tareaDetalleValidarPedido/tarea-detalle-validar-pedido"),
);
const ErrorPage = React.lazy(() => import("../components/error-page"));

export function tareaDetalleValidarPedido() {
  return (
    <Route
      path="/tarea-detalle-validar-pedido"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <TareaDetalleValidarPedido />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
